/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { createPortal } from "react-dom";
import Icon from "../common_components/Icon";
import clsx from "clsx";
import { useHistory } from "react-router-dom";
import NotificationsIndicator from "components/Home/Notifications/Indicator";

function MenuItem({ id, label, path, icon, notificationsKeyIdentity, selected, onClick, betaFeature = false, collapsed = false }) {
    const history = useHistory();
    // Tooltip position for the collapsed menu; rendered in a portal so the nav's overflow doesn't clip it
    const [tooltipPosition, setTooltipPosition] = useState(null);

    const showTooltip = (e) => {
        if (!collapsed) return;
        const rect = e.currentTarget.getBoundingClientRect();
        setTooltipPosition({ top: rect.top + rect.height / 2, left: rect.right + 10 });
    };

    return (
        <div
            className={clsx("nav-item", {
                "nav-item--active": selected,
                "nav-item--with-notifications": Boolean(notificationsKeyIdentity),
            })}
            disabled={!path}
            selected={selected}
            onClick={() => {
                setTooltipPosition(null);
                onClick();
                history.push(path);
            }}
            onMouseEnter={showTooltip}
            onMouseLeave={() => setTooltipPosition(null)}
        >
            <div className="nav-item__icon">
                <Icon name={icon} color="white" />
            </div>
            <div className="nav-item__name hide-nav-small">{label}</div>
            {betaFeature && <Icon name="beta" color="white" size="xlg" />}
            <NotificationsIndicator id={`menu-item-${id}`} identity={notificationsKeyIdentity} className="in-menu" />
            {collapsed &&
                tooltipPosition &&
                createPortal(
                    <div className="nav-tooltip" role="tooltip" style={tooltipPosition}>
                        {label}
                    </div>,
                    document.body
                )}
        </div>
    );
}

export default MenuItem;
